import ru from '../locales/ru.json';
import kk from '../locales/kk.json';

/** Публичная страница: `app` — `/`, `business` — `/business`, `point` — `/p/<pointId>` из QR на постере. */
type PublicPage = 'app' | 'business' | 'point';

/** К какой публичной странице относится адрес. */
function publicPageOf(pathname: string): PublicPage {
  // Регистр не важен — как у роутера SPA и у правила `/p/` в `nginx.conf`.
  const path = pathname.replace(/\/+$/, '').toLowerCase();
  if (path === '/business') return 'business';
  // Ровно `/p` или `/p/<id>`, как правило в `nginx.conf`: у `/p/<id>/ещё` своей
  // страницы нет, это «не найдено».
  if (/^\/p(?:\/[^/]*)?$/.test(path)) return 'point';
  return 'app';
}

/**
 * Хост, под которым картинка превью стоит в собранном HTML.
 *
 * `og:image` обязан быть абсолютным: Telegram и WhatsApp относительный адрес
 * не разрешают и показывают ссылку без картинки. Одна и та же сборка отдаётся с
 * `moneyto.me` и `promo.moneyto.me`, а стейдж — с `s-promo.moneyto.me`, поэтому
 * в HTML стоит прод, а nginx подменяет его на хост запроса (`sub_filter` в
 * `nginx.conf`). Без подмены ссылка всё равно рабочая — на прод.
 */
export const PREVIEW_IMAGE_ORIGIN = 'https://moneyto.me';

/** Метаданные страницы — для статической сборки, где известна страница, а не адрес. */
export function pageMetadata(page: PublicPage, language = 'ru') {
  const locale = language === 'kk' ? 'kk' : 'ru';
  const messages = locale === 'kk' ? kk : ru;
  return {
    ...messages.meta[page],
    // Исходник картинок — `og-images/template.html`; язык на них один, русский,
    // как и у статического HTML.
    image: `${PREVIEW_IMAGE_ORIGIN}/og/${page}.png`,
    // Страница точки — адрес из QR на постере, по одному на точку: тысяча копий
    // одного текста, поиску они не нужны.
    indexable: page !== 'point',
    language: locale,
    ogLocale: locale === 'kk' ? 'kk_KZ' : 'ru_RU',
  };
}

/** Shared by the static HTML build and the browser; no browser globals here. */
export function getPageMetadata(pathname: string, language = 'ru') {
  return pageMetadata(publicPageOf(pathname), language);
}
